import { render, staticRenderFns } from "./ArpFillPropria.vue?vue&type=template&id=2805fae4&scoped=true&"
import script from "./ArpFillPropria.vue?vue&type=script&lang=js&"
export * from "./ArpFillPropria.vue?vue&type=script&lang=js&"
import style0 from "./ArpFillPropria.vue?vue&type=style&index=0&id=2805fae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805fae4",
  null
  
)

export default component.exports